import { SVGProps, Ref, forwardRef } from 'react';

export const SmartphoneFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 0C5 0 4 1 4 8v8c0 7 1 8 8 8s8-1 8-8V8c0-7-1-8-8-8M9.5 4.1v1.8h5V4.1z"
                fill="currentColor"
            />
        </g>
    </svg>
));
SmartphoneFilledSize24Glyph.displayName = 'SmartphoneFilledSize24Glyph';
